<script>
    export default {
        props: ['selected', 'mainForm'],
        data() {
            return {
                tabs: [
                    {
                        label: 'cart',
                        active: true,
                        disabled: false,
                        completed: false
                    },
                    {
                        label: 'billing',
                        active: false,
                        disabled: true,
                        completed: false
                    },
                    {
                        label: 'payment',
                        active: false,
                        disabled: true,
                        completed: false
                    },
                    {
                        label: 'confirm',
                        active: false,
                        disabled: true,
                        completed: false
                    }
                ]
            }
        },
        computed: {
            hasAlreadySaveACard() {
                return !_.isEmpty(this.mainForm.card_brand) && !_.isEmpty(this.mainForm.card_last_four) && !_.isEmpty(this.mainForm.stripe_id)
            }
        },
        watch: {
            selected(tab, oldTab) {
                this.setPrevTabAttributes(oldTab)
                this.setTabAttributes(tab)
            }
        },
        mounted() {
            this.$bus.$on('reset-tabs', () => {
                this.$set(this, 'tabs', [
                    {
                        label: 'cart',
                        active: true,
                        disabled: false,
                        completed: false
                    },
                    {
                        label: 'billing',
                        active: false,
                        disabled: true,
                        completed: false
                    },
                    {
                        label: 'payment',
                        active: false,
                        disabled: true,
                        completed: false
                    },
                    {
                        label: 'confirm',
                        active: false,
                        disabled: true,
                        completed: false
                    }
                ])
            })
        },
        methods: {
            isSelected(tab) {
                let idx = _.findIndex(this.tabs, t => t.label == tab)
                return this.tabs[idx].active
            },
            isDisabled(tab) {
                let idx = _.findIndex(this.tabs, t => t.label == tab)
                return this.tabs[idx].disabled
            },
            isCompleted(tab) {
                let idx = _.findIndex(this.tabs, t => t.label == tab)
                return this.tabs[idx].completed && !this.tabs[idx].active
            },
            onSelectTab(tab) {
                this.setPrevTabAttributes()
                this.setTabAttributes(tab)
                this.$emit('update-tab', tab)
            },
            setPrevTabAttributes(tab = null) {
                let idx = -1;
                if (_.isNull(tab)) {
                    idx = _.findIndex(this.tabs, t => t.label == this.selected)
                } else {
                    idx = _.findIndex(this.tabs, t => t.label == tab)
                }

                this.$set(this.tabs[idx], 'completed', true)
                this.$set(this.tabs[idx], 'active', false)
                this.$set(this.tabs[idx], 'disabled', false)
            },
            setTabAttributes(tab) {
                let idx = _.findIndex(this.tabs, t => t.label == tab)
                this.$set(this.tabs[idx], 'disabled', false)
                this.$set(this.tabs[idx], 'active', true)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/CartNavigationContainer.vue